/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Save_PromptInputs */



/**
* | output |
* | --- |
* | "Save current prompt" |
*
* @param {Assistant_Save_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_save_prompt = /** @type {((inputs?: Assistant_Save_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Save_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer l'invite actuelle")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuelle Eingabeaufforderung speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva il prompt corrente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранить текущий запрос")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar la solicitud actual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存当前提示")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在のプロンプトを保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मौजूदा प्रॉम्प्ट सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Guardar o prompt atual")
	return /** @type {LocalizedString} */ ("Save current prompt")
});